import React from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import { getDeviationNotificationQueue } from '../../../../DeviationPage/redux/helpers';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { ResourceType } from '../../../../types/resource';
import { getRecipientForDeviation } from '../../../utils';
import CoreBadgeList from '../../CoreBadgeList';
const DeviationCoreBadgeList = ({ deviation, className })=>{
    var _deviation_extended;
    return /*#__PURE__*/ React.createElement(CoreBadgeList, {
        className: className,
        badges: ((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.awardedBadges) || [],
        recipient: getRecipientForDeviation(deviation),
        targetTypeId: ResourceType.DEVIATION,
        targetItemId: deviation.deviationId,
        notificationQueueName: getDeviationNotificationQueue(deviation),
        biData: BiData({
            evid: 323,
            sectionname: 'deviation',
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        })
    });
};
DeviationCoreBadgeList.displayName = 'DeviationCoreBadgeList';
export default DeviationCoreBadgeList;
